import { render, staticRenderFns } from "./Jurnalform.vue?vue&type=template&id=282ac7c2"
import script from "./Jurnalform.vue?vue&type=script&lang=js"
export * from "./Jurnalform.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports